import * as api from './utils/api'
import * as woocommerceApi from './utils/woocommerce-api'
import { extractApiErrors } from './utils/ajax'
import { getImage } from './utils/image-loader'
import {
  getBaseModel,
  getComponent,
  getOption,
  getColor
} from './utils/bike-schema'
import { bikeConfigToQuery } from './utils/bike-config'
import { t } from './utils/i18n'

export const ADD_TO_CART_CLICKED = 'ADD_TO_CART_CLICKED'
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR'
export const ADD_TO_CART_SUBMITTED = 'ADD_TO_CART_SUBMITTED'
export const ANGLE_SELECTED = 'ANGLE_SELECTED'
export const BACKGROUND_CLICKED = 'BACKGROUND_CLICKED'
export const BACKGROUND_IMAGE_UPLOADED = 'BACKGROUND_IMAGE_UPLOADED'
export const BACKGROUND_REMOVE_IMAGE = 'BACKGROUND_REMOVE_IMAGE'
export const BACKGROUND_SET_COLOR = 'BACKGROUND_SET_COLOR'
export const BACKGROUND_SET_MODE = 'BACKGROUND_SET_MODE'
export const BASE_MODEL_CLICKED = 'BASE_MODEL_CLICKED'
export const BASE_MODEL_SET = 'BASE_MODEL_SET'
export const BIKE_CONFIG_SET_PARAMS = 'BIKE_CONFIG_SET_PARAMS'
export const BIKE_IMAGE_LOADED = 'BIKE_IMAGE_LOADED'
export const BIKE_IMAGE_LOADING = 'BIKE_IMAGE_LOADING'
export const CART_DISCLAIMER_CLICKED = 'CART_DISCLAIMER_CLICKED'
export const CLOSE_POPOVER = 'CLOSE_POPOVER'
export const COLOR_CATEGORY_CLICKED = 'COLOR_CATEGORY_CLICKED'
export const COMPONENT_CLICKED = 'COMPONENT_CLICKED'
export const COMPONENT_HOVERED = 'COMPONENT_HOVERED'
export const COMPONENT_TOGGLE = 'COMPONENT_TOGGLE'
export const COMPONENT_HIGHLIGHTED = 'COMPONENT_HIGHLIGHTED'
export const COMPONENT_UNHIGHLIGHTED = 'COMPONENT_UNHIGHLIGHTED'
export const CUSTOM_COLOR_CHOSEN = 'CUSTOM_COLOR_CHOSEN'
export const DISCLAIMER_CLICKED = 'DISCLAIMER_CLICKED'
export const DOWNLOAD_JPEG = 'DOWNLOAD_JPEG'
export const FULL_PAINT_CLICKED = 'FULL_PAINT_CLICKED'
export const FULL_PAINT_SET_RAL = 'FULL_PAINT_SET_RAL'
export const GET_QUOTE_CLICKED = 'GET_QUOTE_CLICKED'
export const GET_QUOTE_ERROR = 'GET_QUOTE_ERROR'
export const GET_QUOTE_SET_QUANTITY = 'GET_QUOTE_SET_QUANTITY'
export const GET_QUOTE_SET_COMPANY_NAME = 'GET_QUOTE_SET_COMPANY_NAME'
export const GET_QUOTE_SET_COMPANY_ADDRESS_LINE1 =
  'GET_QUOTE_SET_COMPANY_ADDRESS_LINE1'
export const GET_QUOTE_SET_COMPANY_ADDRESS_LINE2 =
  'GET_QUOTE_SET_COMPANY_ADDRESS_LINE2'
export const GET_QUOTE_SET_COMPANY_COUNTRY = 'GET_QUOTE_SET_COMPANY_COUNTRY'
export const GET_QUOTE_SET_COMPANY_VAT_NO = 'GET_QUOTE_SET_COMPANY_VAT_NO'
export const GET_QUOTE_SET_COMPANY_EMAIL = 'GET_QUOTE_SET_COMPANY_EMAIL'
export const GET_QUOTE_SET_COMPANY_TELEPHONE = 'GET_QUOTE_SET_COMPANY_TELEPHONE'
export const GET_QUOTE_SET_CONTACT_PERSON = 'GET_QUOTE_SET_CONTACT_PERSON'
export const GET_QUOTE_SET_COMMENTS = 'GET_QUOTE_SET_COMMENTS'
export const GET_QUOTE_SUBMITTED = 'GET_QUOTE_SUBMITTED'
export const GET_QUOTE_SUCCESS = 'GET_QUOTE_SUCCESS'
export const INFO_CLICKED = 'INFO_CLICKED'
export const INITIALS_SET = 'INITIALS_SET'
export const INQUIRY_CLICKED = 'INQUIRY_CLICKED'
export const INQUIRY_ERROR = 'INQUIRY_ERROR'
export const INQUIRY_SET_FROM_EMAIL = 'INQUIRY_SET_FROM_EMAIL'
export const INQUIRY_SET_FROM_NAME = 'INQUIRY_SET_FROM_NAME'
export const INQUIRY_SET_FROM_PHONE = 'INQUIRY_SET_FROM_PHONE'
export const INQUIRY_SET_FROM_ADDRESS = 'INQUIRY_SET_FROM_ADDRESS'
export const INQUIRY_SET_MESSAGE = 'INQUIRY_SET_MESSAGE'
export const INQUIRY_SUBMITTED = 'INQUIRY_SUBMITTED'
export const INQUIRY_SUCCESS = 'INQUIRY_SUCCESS'
export const LOGO_CLICKED = 'LOGO_CLICKED'
export const LOGO_REMOVE = 'LOGO_REMOVE'
export const LOGO_UPLOADED = 'LOGO_UPLOADED'
export const NEXT_CLICKED = 'NEXT_CLICKED'
export const OPTION_CLICKED = 'OPTION_CLICKED' // closes popover, starts color flow maybe
export const OPTION_SELECTED = 'OPTION_SELECTED' // just sets it
export const PDF_CLICKED = 'PDF_CLICKED'
export const PRESETS_CLICKED = 'PRESETS_CLICKED'
export const VIDEO_CLICKED = 'VIDEO_CLICKED'
export const QUANTITY_SET = 'QUANTITY_SET'
export const SETTINGS_CLICKED = 'SETTINGS_CLICKED'
export const SHARE_CLICKED = 'SHARE_CLICKED'
export const SHARE_ERROR = 'SHARE_ERROR'
export const SHARE_SET_FROM_EMAIL = 'SHARE_SET_FROM_EMAIL'
export const SHARE_SET_FROM_NAME = 'SHARE_SET_FROM_NAME'
export const SHARE_SET_MESSAGE = 'SHARE_SET_MESSAGE'
export const SHARE_SET_TO_EMAIL = 'SHARE_SET_TO_EMAIL'
export const SHARE_SET_TO_NAME = 'SHARE_SET_TO_NAME'
export const SHARE_SUBMITTED = 'SHARE_SUBMITTED'
export const SHARE_SUCCESS = 'SHARE_SUCCESS'
export const SPECIFICATION_CLICKED = 'SPECIFICATION_CLICKED'
export const SPECIFICATIONS_CLICKED = 'SPECIFICATIONS_CLICKED'
export const UNDO_CLICKED = 'UNDO_CLICKED'
export const REDO_CLICKED = 'REDO_CLICKED'
export const RESET_UNDO = 'RESET_UNDO'

function wrapBikeConfigChange(fn) {
  return function (...args) {
    return function (dispatch) {
      dispatch(fn(...args))
      return dispatch(bikeImageReload())
    }
  }
}

function wrapBikeConfigChangeConfirm(fn) {
  return function (...args) {
    return function (dispatch, getState) {
      const { bikeConfigPristine } = getState()
      if (
        !bikeConfigPristine &&
        !window.confirm(t('bike_config_change_confirm'))
      ) {
        return
      }
      dispatch(fn(...args))
      return dispatch(bikeImageReload())
    }
  }
}

export const addToCartClicked = () => ({
  type: ADD_TO_CART_CLICKED
})

export const getQuoteClicked = () => ({
  type: GET_QUOTE_CLICKED
})

export const addToCartError = (errors) => ({
  type: ADD_TO_CART_ERROR,
  errors
})

export const initialsSet = (value) => {
  return {
    type: INITIALS_SET,
    value
  }
}

export const addToCartSubmitted = () => ({
  type: ADD_TO_CART_SUBMITTED
})

export const addToCartSubmit = () => (dispatch, getState) => {
  dispatch(addToCartSubmitted())
  const { bikeConfig, quantity } = getState()
  return woocommerceApi.addToCart(bikeConfig, quantity).then(
    () => {
      window.location.href = '/cart/'
    },
    (e) => {
      dispatch(addToCartError(extractApiErrors(e)))
    }
  )
}

export const backgroundClicked = () => ({
  type: BACKGROUND_CLICKED
})

export const backgroundImageUploaded = (url) => ({
  type: BACKGROUND_IMAGE_UPLOADED,
  url
})

export const backgroundRemoveImage = () => ({
  type: BACKGROUND_REMOVE_IMAGE
})

export const backgroundSetColor = (value) => ({
  type: BACKGROUND_SET_COLOR,
  value: !value.match(/^#/) ? '#' + value : value
})

export const backgroundSetMode = (value) => ({
  type: BACKGROUND_SET_MODE,
  value
})

export const baseModelClicked = () => ({
  type: BASE_MODEL_CLICKED
})

export const baseModelSet = wrapBikeConfigChangeConfirm((baseModelId) => ({
  type: BASE_MODEL_SET,
  baseModelId
}))

export const bikeConfigSetParams = wrapBikeConfigChangeConfirm((params) => ({
  type: BIKE_CONFIG_SET_PARAMS,
  params
}))

export const bikeImageLoaded = (choices, logos) => {
  return {
    type: BIKE_IMAGE_LOADED,
    choices,
    logos
  }
}

export const bikeImageLoading = () => ({
  type: BIKE_IMAGE_LOADING
})

export const angleSelected = wrapBikeConfigChange((angle) => ({
  type: ANGLE_SELECTED,
  angle
}))

export const bikeImageReload = () => async (dispatch, getState) => {
  dispatch(bikeImageLoading())

  // Get bike config from state
  const { bikeConfig } = getState()
  const { baseModelId, angle } = bikeConfig
  const baseModel = getBaseModel(baseModelId)
  const DEFAULT_Z_INDEX = 0
  // Choices
  const isAngle = angle && angle !== 'none' ? angle + '/' : ''
  const baseImgUrl = `/images/options/${baseModelId}/${isAngle}base/base.png`
  let choices = [
    {
      imgUrl: baseImgUrl,
      componentId: 'base',
      optionId: 'base',
      zIndex: 1,
      ignoreMouse: true
    }
  ]
  let logos = []
  let imgUrls = [baseImgUrl]
  bikeConfig.choices.forEach(
    ({
      componentId,
      optionId,
      ral,
      logo,
      logo_right,
      logo_left,
      logo_front
    }) => {
      const component = getComponent(baseModel, componentId)
      const option = getOption(component, optionId)
      const color = ral && getColor(ral)
      if (!option.no_image) {
        const dir = `/images/options/${baseModelId}/${isAngle}${componentId}`
        const imgUrl = `${dir}/${optionId}.png`
        const secondaryImgUrl = option.secondary_image
          ? `${dir}/${optionId}-2.png`
          : null
        choices.push({
          imgUrl,
          secondaryImgUrl,
          componentId,
          optionId,
          hex: color && color.hex,
          zIndex: option.z_index || DEFAULT_Z_INDEX
        })
        imgUrls.push(imgUrl)
        if (secondaryImgUrl) {
          imgUrls.push(secondaryImgUrl)
        }
      }
      if (logo) {
        logos.push({
          componentId,
          imgUrl: logo,
          placement: option.logo_placement
        })
        imgUrls.push(logo)
      }
      if (logo_right) {
        logos.push({
          componentId,
          imgUrl: logo_right,
          placement: option.logo_placement_right,
          angle: 'right'
        })
        imgUrls.push(logo_right)
      }
      if (logo_left) {
        logos.push({
          componentId,
          imgUrl: logo_left,
          placement: option.logo_placement_left,
          angle: 'left'
        })
        imgUrls.push(logo_left)
      }
      if (logo_front) {
        logos.push({
          componentId,
          imgUrl: logo_front,
          placement: option.logo_placement_front,
          angle: 'front'
        })
        imgUrls.push(logo_front)
      }
    }
  )
  choices.sort((a, b) => {
    let d = a.zIndex - b.zIndex
    if (d !== 0) {
      return d
    }
    return a.componentId.localeCompare(b.componentId)
  })

  // Also load background image (so first-paint-handler can fire at the right time)
  if (bikeConfig.background.image) {
    imgUrls.push(bikeConfig.background.image)
  }
  // Load all images
  await Promise.all(imgUrls.map((imgUrl_1) => getImage(imgUrl_1).safeLoad()))
  dispatch(bikeImageLoaded(choices, logos))
}

export const closePopover = () => ({
  type: CLOSE_POPOVER
})

export const colorCategoryClicked = (ral) => ({
  type: COLOR_CATEGORY_CLICKED,
  ral
})

export const componentClicked = (componentId) => ({
  type: COMPONENT_CLICKED,
  componentId
})

export const componentHovered = (componentId) => ({
  type: COMPONENT_HOVERED,
  componentId
})

export const componentToggle = () => ({
  type: COMPONENT_TOGGLE
})

export const componentHighlighted = (componentId) => ({
  type: COMPONENT_HIGHLIGHTED,
  componentId
})

export const componentUnhighlighted = () => ({
  type: COMPONENT_UNHIGHLIGHTED
})

export const customColorChosen = wrapBikeConfigChange(
  (componentId, optionId, ral, bool) => ({
    type: CUSTOM_COLOR_CHOSEN,
    componentId,
    optionId,
    ral,
    bool
  })
)

export const disclaimerClicked = () => ({
  type: DISCLAIMER_CLICKED
})

export const cartDisclaimerClicked = () => ({
  type: CART_DISCLAIMER_CLICKED
})

export const downloadJpeg = () => ({
  type: DOWNLOAD_JPEG
})

export const fullPaintClicked = () => ({
  type: FULL_PAINT_CLICKED
})

export const fullPaintSetRal = wrapBikeConfigChangeConfirm((ral) => ({
  type: FULL_PAINT_SET_RAL,
  ral
}))

export const infoClicked = () => ({
  type: INFO_CLICKED
})

export const inquiryClicked = () => ({
  type: INQUIRY_CLICKED
})

export const inquiryError = (errors) => ({
  type: INQUIRY_ERROR,
  errors
})

export const inquirySetFromEmail = (value) => ({
  type: INQUIRY_SET_FROM_EMAIL,
  value
})

export const inquirySetFromPhone = (value) => ({
  type: INQUIRY_SET_FROM_PHONE,
  value
})

export const inquirySetFromAddress = (value) => ({
  type: INQUIRY_SET_FROM_ADDRESS,
  value
})

export const inquirySetFromName = (value) => ({
  type: INQUIRY_SET_FROM_NAME,
  value
})

export const inquirySetMessage = (value) => ({
  type: INQUIRY_SET_MESSAGE,
  value
})

export const inquirySubmit = () => (dispatch, getState) => {
  dispatch(inquirySubmitted())
  const {
    bikeConfig,
    inquiry: { fromEmail, fromName, fromPhone, fromAddress, message }
  } = getState()
  return api
    .post('/inquiry', {
      payload: {
        from_email: fromEmail,
        from_name: fromName,
        from_phone: fromPhone,
        from_address: fromAddress,
        message: message,
        bike_config: bikeConfigToQuery(bikeConfig),
        hostname: window.location.hostname
      }
    })
    .then(
      () => {
        dispatch(inquirySuccess())
      },
      (e) => {
        dispatch(inquiryError(extractApiErrors(e)))
      }
    )
}

export const inquirySubmitted = () => ({
  type: INQUIRY_SUBMITTED
})

export const inquirySuccess = () => ({
  type: INQUIRY_SUCCESS
})

export const getQuoteSetQuantity = (quantity) => ({
  type: 'GET_QUOTE_SET_QUANTITY',
  quantity
})

export const getQuoteSetCompanyName = (companyName) => ({
  type: 'GET_QUOTE_SET_COMPANY_NAME',
  companyName
})

export const getQuoteSetCompanyAddressLine1 = (companyAddressLine1) => ({
  type: 'GET_QUOTE_SET_COMPANY_ADDRESS_LINE1',
  companyAddressLine1
})

export const getQuoteSetCompanyAddressLine2 = (companyAddressLine2) => ({
  type: 'GET_QUOTE_SET_COMPANY_ADDRESS_LINE2',
  companyAddressLine2
})

export const getQuoteSetCompanyCountry = (companyCountry) => ({
  type: 'GET_QUOTE_SET_COMPANY_COUNTRY',
  companyCountry
})

export const getQuoteSetCompanyVatNo = (companyVatNo) => ({
  type: 'GET_QUOTE_SET_COMPANY_VAT_NO',
  companyVatNo
})

export const getQuoteSetCompanyEmail = (companyEmail) => ({
  type: 'GET_QUOTE_SET_COMPANY_EMAIL',
  companyEmail
})

export const getQuoteSetCompanyTelephone = (companyTelephone) => ({
  type: 'GET_QUOTE_SET_COMPANY_TELEPHONE',
  companyTelephone
})

export const getQuoteSetContactPerson = (contactPerson) => ({
  type: 'GET_QUOTE_SET_CONTACT_PERSON',
  contactPerson
})

export const getQuoteSetComments = (comments) => ({
  type: 'GET_QUOTE_SET_COMMENTS',
  comments
})

export const getQuoteSubmit = () => (dispatch, getState) => {
  dispatch(getQuoteSubmitted())
  const {
    bikeConfig,
    getQuote: {
      quantity,
      companyName,
      companyAddressLine1,
      companyAddressLine2,
      companyCountry,
      companyVatNo,
      companyEmail,
      companyTelephone,
      contactPerson,
      comments
    }
  } = getState()
  return api
    .post('/get-quote', {
      payload: {
        quantity,
        company_name: companyName,
        company_address_line1: companyAddressLine1,
        company_address_line2: companyAddressLine2,
        company_country: companyCountry,
        company_vat_no: companyVatNo,
        company_email: companyEmail,
        company_telephone: companyTelephone,
        contact_person: contactPerson,
        comments,
        bike_config: bikeConfigToQuery(bikeConfig),
        hostname: window.location.hostname
      }
    })
    .then(
      () => {
        dispatch(getQuoteSuccess())
      },
      (e) => {
        dispatch(getQuoteError(extractApiErrors(e)))
      }
    )
}

export const getQuoteSubmitted = () => ({
  type: 'GET_QUOTE_SUBMITTED'
})

export const getQuoteSuccess = () => ({
  type: 'GET_QUOTE_SUCCESS'
})

export const getQuoteError = (errors) => ({
  type: 'GET_QUOTE_ERROR',
  errors
})

export const logoClicked = () => ({
  type: LOGO_CLICKED
})

export const logoRemove = wrapBikeConfigChange((componentId, logoAngle) => ({
  type: LOGO_REMOVE,
  componentId,
  logoAngle
}))

export const logoUploaded = wrapBikeConfigChange((componentId, logo, angle) => {
  let data = { logo }
  if (angle === 'right') {
    data = { logo_right: logo }
  }
  if (angle === 'left') {
    data = { logo_left: logo }
  }
  if (angle === 'front') {
    data = { logo_front: logo }
  }
  return {
    type: LOGO_UPLOADED,
    componentId,
    data
  }
})

export const nextColorClicked = (next, fullPaintPopoverOpen) => ({
  type: NEXT_CLICKED,
  next,
  fullPaintPopoverOpen
})

export const optionClicked = wrapBikeConfigChange(
  (componentId, optionId, keepOpen = false) => ({
    type: OPTION_CLICKED,
    componentId,
    optionId,
    keepOpen
  })
)

export const optionSelected = (componentId, optionId) => ({
  type: OPTION_SELECTED,
  componentId,
  optionId
})

export const pdfClicked = () => ({
  type: PDF_CLICKED
})

export const presetsClicked = () => ({
  type: PRESETS_CLICKED
})

export const videoClicked = () => ({
  type: VIDEO_CLICKED
})

export const shareClicked = () => ({
  type: SHARE_CLICKED
})

export const settingsClicked = () => ({
  type: SETTINGS_CLICKED
})

export const shareError = (errors) => ({
  type: SHARE_ERROR,
  errors
})

export const shareSetFromEmail = (value) => ({
  type: SHARE_SET_FROM_EMAIL,
  value
})

export const shareSetFromName = (value) => ({
  type: SHARE_SET_FROM_NAME,
  value
})

export const shareSetMessage = (value) => ({
  type: SHARE_SET_MESSAGE,
  value
})

export const shareSetToEmail = (value) => ({
  type: SHARE_SET_TO_EMAIL,
  value
})

export const shareSetToName = (value) => ({
  type: SHARE_SET_TO_NAME,
  value
})

export const shareSubmit = () => (dispatch, getState) => {
  dispatch(shareSubmitted())
  const {
    bikeConfig,
    share: { fromEmail, fromName, toEmail, toName, message }
  } = getState()
  return api
    .post('/share', {
      payload: {
        from_email: fromEmail,
        from_name: fromName,
        to_email: toEmail,
        to_name: toName,
        message: message,
        bike_config: bikeConfigToQuery(bikeConfig),
        hostname: window.location.hostname
      }
    })
    .then(
      () => {
        dispatch(shareSuccess())
      },
      (e) => {
        dispatch(shareError(extractApiErrors(e)))
      }
    )
}

export const shareSubmitted = () => ({
  type: SHARE_SUBMITTED
})

export const shareSuccess = () => ({
  type: SHARE_SUCCESS
})

export const specificationClick = (id) => (dispatch) => {
  dispatch(specificationClicked(id))
}

export const specificationClicked = (id) => ({
  type: SPECIFICATION_CLICKED,
  id
})

export const specificationsClicked = () => ({
  type: SPECIFICATIONS_CLICKED
})

export const undoClicked = (choicesToApply, redo = false) => ({
  type: UNDO_CLICKED,
  choicesToApply,
  redo
})

export const resetUndo = () => ({
  type: RESET_UNDO
})

export const redoClicked = () => ({
  type: REDO_CLICKED
})

export const quantitySet = (value) => ({
  type: QUANTITY_SET,
  value
})
